module.exports = __webpack_public_path__ + "assets/img/润居房.b191f6a9.png";